import { render } from "./GestionSolicitudesTecnico.vue?vue&type=template&id=51eb332f"
import script from "./GestionSolicitudesTecnico.vue?vue&type=script&lang=js"
export * from "./GestionSolicitudesTecnico.vue?vue&type=script&lang=js"

import "./GestionSolicitudesTecnico.vue?vue&type=style&index=0&id=51eb332f&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__